export default {
      id: "na-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#na-usage",
      toString: function () {
        return this.url;
      }
    }